const Modalidades = {
  NOVO_CREDENCIAMENTO: 'NC',
  RECREDENCIAMENTO: 'R',
  FINALIZADA_PRIMEIRA_ETAPA: 'F1',
  ATUALIZACAO_INDICACAO: 'AI',
  INDICACAO_FINALIZADA: 'IF',
};

export default Object.freeze(Modalidades);
